import React from 'react'

type HeadingProps = React.ComponentPropsWithoutRef<'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'> & {
    size?: 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs'
}

const Heading = ({ children, className, size = 'lg', ...props }: HeadingProps) => {
    const sizeClasses = {
        xxl: 'text-heading-2xl',
        xl: 'text-heading-xl',
        lg: 'text-heading-lg',
        md: 'text-heading-md',
        sm: 'text-heading-sm',
        xs: 'text-heading-xs',
    }

    const Component =
        size === 'xxl'
            ? 'h1'
            : size === 'xl'
              ? 'h2'
              : size === 'lg'
                ? 'h3'
                : size === 'md'
                  ? 'h4'
                  : size === 'sm'
                    ? 'h5'
                    : 'h6'

    return (
        <Component {...props} className={`font-bold ${sizeClasses[size]} ${className}`}>
            {children}
        </Component>
    )
}

export default Heading
